/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import BirthContainer from './birth/container/BirthContainer';

function DeliveryContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Delivery Transactions</div>
      <div className="generic-module-nav">
        {Acl(permissions, ['VIEW DELIVERY TRANSACTIONS']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/delivery/birth"
          >
            Birth Certificate
          </NavLink>
        )}
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/birth`} />}
        />
        <Route path={`${match.path}/birth`} component={BirthContainer} />
      </Switch>
    </div>
  );
}

DeliveryContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(DeliveryContainer);
